import { render, staticRenderFns } from "./AddText.vue?vue&type=template&id=2701d365&scoped=true&"
import script from "./AddText.vue?vue&type=script&lang=js&"
export * from "./AddText.vue?vue&type=script&lang=js&"
import style0 from "./AddText.vue?vue&type=style&index=0&id=2701d365&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701d365",
  null
  
)

export default component.exports